import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { InfoIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SmallGrayText = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "small",
    color: "text-primary-disabled",
    children: children
  });
};
const ReportingAIAssistantInsightsDisclaimer = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(SmallGrayText, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.platformReport.reportVisualizationInsights.disclaimer.about"
      })
    }), "\xA0", /*#__PURE__*/_jsx(Text, {
      as: "small",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "reporting-enablement.platformReport.reportVisualizationInsights.disclaimer.seeTerms_jsx",
        options: {
          external: true,
          href: 'https://legal.hubspot.com/hubspot-beta-terms',
          target: 'blank'
        },
        elements: {
          Link
        }
      })
    }), /*#__PURE__*/_jsx(InfoIcon, {
      color: "text-primary-disabled"
    })]
  });
};
export default ReportingAIAssistantInsightsDisclaimer;